import { applySegmentColor } from './apply-segment-color.js';
import {
  CustomColorPalette,
  ColorPalette,
} from '../../../core/types/color-palette.js';
import { MultiMeterBarSegmentProps } from '../types/multi-meter-bar-chart.js';

export const buildSegmentData = (
  segment: MultiMeterBarSegmentProps,
  colorPalette: ColorPalette | CustomColorPalette,
  index: number,
) => {
  const color =
    segment.color ||
    applySegmentColor(segment.name, index, colorPalette, segment.color);

  const segmentId = `${segment.name}-${segment.value}`;

  return {
    color,
    name: segment.name,
    id: segmentId,
    value: segment.value,
  };
};
